// src/services/queries/macro/macroOverviewQueries.ts

import type { QueryFunction } from "@tanstack/react-query";
import { macroQueryKeys } from "@/constants/queryKeys";
import { TIME } from "@/constants/app";
import { API_BASE_URL } from "@/services";
import type { MacroOverviewResponse } from "@/types/dashboards/macro";

/**
 * Fetch macro overview data from backend API
 */
export const fetchMacroOverview: QueryFunction<MacroOverviewResponse> = async ({
  signal,
}) => {
  const requestInit: RequestInit = {};
  if (signal) {
    requestInit.signal = signal;
  }

  const response = await fetch(`${API_BASE_URL}/macroIndicators/overview`, requestInit);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const data = (await response.json()) as MacroOverviewResponse;
  return data;
};

// Query options factory
export const macroOverviewQueryOptions = () => ({
  queryKey: macroQueryKeys.overview(),
  queryFn: fetchMacroOverview,
  staleTime: 5 * TIME.MINUTE, // 5 minutes
  gcTime: 10 * TIME.MINUTE, // 10 minutes
  retry: 2,
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
});
